










import { Component, Vue } from 'vue-property-decorator'
import { fetchUser } from '@/api'
import { UserResponse } from '@/api/types'
import Cookies from 'js-cookie'

@Component({})
export default class Home extends Vue {
  user: UserResponse | null = null
  buildTime: string = process.env.VUE_APP_BUILD_TIME || ''

  async mounted () {
    const userId = Cookies.get('userId')
    this.user = await fetchUser(userId || '')
  }
}
